import { useMutation } from '@apollo/client/react';
import { toast } from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  DatevLoginDocument,
  type DatevLoginMutation,
} from '../../../datev-service/gql/graphql';
import { useDatevServiceClient } from '../../../lib/ApolloClient';
import { datevServiceLohnabrechnungsart } from '../constants/lohnabrechnungsart';
import type { LoginFormInput } from '../LoginFormSchema';

/** Starts the DATEV login and sends the browser to DATEV on success. */
export function useDatevLogin(): (value: LoginFormInput) => Promise<void> {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [login] = useMutation(DatevLoginDocument, {
    client: useDatevServiceClient(),
  });

  // oxlint-disable-next-line complexity
  return async (value) => {
    const result = await login({
      variables: {
        input: {
          beraternummer: value.beraternummer.trim(),
          mandantennummer: value.mandantennummer.trim(),
          lohnabrechnungsart:
            datevServiceLohnabrechnungsart[value.lohnabrechnungsart],
        },
      },
    }).then(
      ({ data }): DatevLoginMutation['login'] | undefined => data?.login,
      (): undefined => undefined,
    );

    if (
      result?.__typename === 'LoginResultSuccess' &&
      result.authorizationUrl
    ) {
      window.location.assign(result.authorizationUrl);
    } else if (
      result?.__typename === 'LoginResultFailure' &&
      result.failure?.__typename === 'AlreadyLoggedIn'
    ) {
      toast({
        variant: 'information',
        title: t('domain.datev.login.error.alreadyLoggedIn'),
      });
      navigate('/datev');
    } else {
      toast({
        variant: 'error',
        title: t('domain.datev.login.error.generic'),
      });
    }
  };
}
